module.exports = __webpack_public_path__ + "static/media/paper_featured.4133c6bb.jpg";